/*
 * ReleaseDialogErrors.tsx  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { isNonEmptyArray } from "@adapptio/lib-shared";
import { ERROR_LIST_CATEGORY, IErrorListGroup } from "../../../../ui/components/ErrorList/ErrorListTypes";
import { ErrorList } from "../../../../ui/components/ErrorList/ErrorList";

export interface IReleaseDialogErrorsProps {
	className?: string;
	errors: IErrorListGroup[];
}

export const ReleaseDialogErrors: React.FC<IReleaseDialogErrorsProps> = ({ className, errors }) => {
	const baseClass = BEM("edt-release-dialog-errors");

	const hasErrors = isNonEmptyArray(errors);

	if (className) {
		baseClass.add(className);
	}

	return (
		<div className={baseClass.toClassName()}>
			{hasErrors ? (
				<>
					<div className={baseClass.element("title").toClassName()}>
						Application has the following errors:
					</div>
					<ErrorList
						className={baseClass.element("list").toClassName()}
						errorGroups={errors}
						category={ERROR_LIST_CATEGORY.ALL}
					/>
				</>
			) : (
				<div className={baseClass.element("title").toClassName()}>Application is without errors.</div>
			)}
		</div>
	);
};
